/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChallengesListResponseChallengesInner } from './ChallengesListResponseChallengesInner';
import {
    ChallengesListResponseChallengesInnerFromJSON,
    ChallengesListResponseChallengesInnerFromJSONTyped,
    ChallengesListResponseChallengesInnerToJSON,
    ChallengesListResponseChallengesInnerToJSONTyped,
} from './ChallengesListResponseChallengesInner';

/**
 * 
 * @export
 * @interface ChallengesListResponse
 */
export interface ChallengesListResponse {
    /**
     * 
     * @type {Array<ChallengesListResponseChallengesInner>}
     * @memberof ChallengesListResponse
     */
    challenges?: Array<ChallengesListResponseChallengesInner>;
}

/**
 * Check if a given object implements the ChallengesListResponse interface.
 */
export function instanceOfChallengesListResponse(value: object): value is ChallengesListResponse {
    return true;
}

export function ChallengesListResponseFromJSON(json: any): ChallengesListResponse {
    return ChallengesListResponseFromJSONTyped(json, false);
}

export function ChallengesListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengesListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'challenges': json['challenges'] == null ? undefined : ((json['challenges'] as Array<any>).map(ChallengesListResponseChallengesInnerFromJSON)),
    };
}

export function ChallengesListResponseToJSON(json: any): ChallengesListResponse {
    return ChallengesListResponseToJSONTyped(json, false);
}

export function ChallengesListResponseToJSONTyped(value?: ChallengesListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'challenges': value['challenges'] == null ? undefined : ((value['challenges'] as Array<any>).map(ChallengesListResponseChallengesInnerToJSON)),
    };
}

